import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import moment from 'moment';
import injectSheet from 'react-jss';
import { Popover, Divider, ListItem } from 'material-ui';
import pluralize from 'pluralize';

import EmptyCircle from 'material-ui/svg-icons/toggle/radio-button-unchecked';
import FilledCircle from 'material-ui/svg-icons/image/brightness-1';
import CommentIcon from 'material-ui/svg-icons/communication/chat-bubble-outline';

const styles = {
  wrapper: { width: '450px', overflowY: 'hidden' },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 12px 6px',
  },
  popoverDiv: {
    maxHeight: 'calc(100vh)',
    overflow: 'hidden',
  },
  list: {
    maxHeight: 'calc(100vh - 70px)',
    overflowY: 'scroll',
  },
  secondaryText: {
    fontSize: '12px',
    marginTop: '4px',
    display: 'flex',
    alignItems: 'center',
    height: 'inherit !important',
    minHeight: '16px',
    '& p': {
      paddingTop: 0,
      marginBottom: 1,
    },
  },
  unreadIconStyle: {
    color: '#ff4081 !important',
  },
  iconStyle: {
    color: 'rgba(0, 0, 0, 0.44) !important',
  },
  onlineStatusIcon: {
    color: '#529A1D !important',
    width: '0.7em !important',
    height: '0.7em !important',
    marginLeft: '0.4em',
  },
  messageRow: {
    '&.unread': {
      backgroundColor: 'rgb(244, 246, 250) !important',
    },
    '&.unread:hover': {
      backgroundColor: 'rgb(221, 223, 227) !important',
    },
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'rows',
    textAlign: 'right',
    marginRight: '0.5em',
  },
  topRightSecondary: {
    cursor: 'pointer',
    color: '#e65100',
    marginRight: '16px',
    fontSize: '10px',
    '&:hover': {
      color: '#ff9800',
    },
  },
  rightSideText: {
    fontSize: '0.7em',
    color: 'rgb(0,0,0,0.4)',
  },
  rightSideIcon: {
    width: '0.7em !important',
    height: '0.7em !important',
  },
  pointerCursor: {
    cursor: 'pointer',
  },
  footer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 12px 6px',
  },
};

class PopoverList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      open: false,
    };
  }

  formatDate = (timestamp) => {
    // const daysDiff = moment().diff(moment(timestamp), 'days');
    // if (daysDiff < 1) return moment(timestamp).format('h:mm  a');
    // if (daysDiff < 7) return moment(timestamp).format('Last dddd');
    // return moment(timestamp).format('MMM D');
    // return moment(`${R.slice(0, -3, timestamp)}Z`).from(moment());
    return moment(timestamp).calendar(null, {
      sameDay: 'h:mm a',
      lastDay: '[Yesterday]',
      lastWeek: '[Last] dddd',
      sameElse: 'D MMM YY',
    });
  }

  actionClose = laterDo => () => {
    this.setState({ open: false });
    laterDo();
  };

  closeList = () => this.state.open && this.setState({ open: false });

  render() {
    const { open, anchorEl } = this.state;
    const {
      bottomLeftAction,
      bottomLeftText,
      bottomRightAction,
      bottomRightText,
      children,
      classes: css,
      clickItem,
      list,
      title,
      topRightAction,
      topRightText,
      topRightSecondaryText,
      topRightSecondaryAction,
    } = this.props;
    return (
      <div>
        {children
          ? React.cloneElement(children, {
            onTouchTap: (event) => {
              if (!this.state.anchorEl) {
                this.setState({ anchorEl: event.currentTarget, open: !this.state.open });
              } else {
                this.setState({ open: !this.state.open });
              }
            },
          })
          : undefined}
        <Popover
          open={open}
          anchorEl={anchorEl}
          onRequestClose={this.closeList}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          className={css.wrapper}
        >
          <div className={css.popoverDiv}>
            <div className={css.header}>
              <b>{title}</b>
              {/* <a
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  const allActivityIds = R.pluck('id', list);
                  markAsRead(allActivityIds);
                }}
              >
                Mark all as Read
              </a> */}
              <div className="flex-center">
                {topRightSecondaryAction ? (
                  <a
                    className={css.topRightSecondary}
                    onClick={topRightSecondaryAction}
                  >
                    {topRightSecondaryText}
                  </a>
                ) : (
                  <span />
                )}
                {topRightText && (
                  <a className={css.pointerCursor} onClick={this.actionClose(topRightAction)}>
                    {topRightText}
                  </a>
                )}
              </div>
            </div>
            <Divider />
            {R.isEmpty(list) && (
              <div style={{ textAlign: 'center', height: '100px', paddingTop: '40px' }}>
                You don't have any {pluralize(title).toLowerCase()}.
              </div>
            )}
            <div className={css.list}>
              {list.map(
                ({
                  id,
                  itemActions = [],
                  unread,
                  leftIcon,
                  isOnline,
                  otherSideName,
                  subject,
                  timestamp,
                  text,
                  firstRowAction,
                  clickItem: elClickItem,
                }) => (
                  <div key={id}>
                    <ListItem
                      className={`${css.messageRow}${unread ? ' unread' : ''}`}
                      leftIcon={leftIcon || <CommentIcon className={css.iconStyle} />}
                      primaryText={(
                        <div
                          style={{
                            fontSize: '13px',
                            cursor: firstRowAction ? 'pointer' : 'inherit',
                          }}
                          {...(firstRowAction
                            ? { onTouchTap: this.actionClose(firstRowAction) }
                            : {})}
                        >
                          {otherSideName || 'Unnamed Company'}
                          {
                            isOnline && <FilledCircle className={css.onlineStatusIcon} />
                          }
                        </div>
                      )}
                      secondaryText={(
                        <div className={css.secondaryText}>
                          {itemActions.length > 0 && (
                            itemActions.map(Button => Button)
                          )}
                          {
                            !text && subject ? <b>{subject}</b> : ''
                          }
                          {
                            text && (text.indexOf('<p') > -1 || text.indexOf('<br/>') > -1 || text.indexOf('<div>') > -1) ? (<span
                              dangerouslySetInnerHTML={{ __html: text }}
                            />) : text
                          }
                        </div>
                      )}
                      rightIconButton={(
                        <div className={css.rightSide}>
                          <div className={css.rightSideText}>{this.formatDate(timestamp)}</div>
                          {unread ? (
                            <FilledCircle className={`${css.unreadIconStyle} ${css.rightSideIcon}`} />
                          ) : (
                            <EmptyCircle className={`${css.iconStyle} ${css.rightSideIcon}`} />
                          )}
                        </div>
                      )}
                      {...(clickItem && !elClickItem
                        ? {
                          onTouchTap: this.actionClose(() => {
                            clickItem(id);
                          }),
                        }
                        : {})}
                      {...(elClickItem
                        ? {
                          onTouchTap: this.actionClose(elClickItem),
                        }
                        : {})}
                      {...(!clickItem && !elClickItem ? { disabled: true } : {})}
                    />
                    <Divider />
                  </div>
                ),
              )}
            </div>
            {(bottomRightText || bottomLeftText) && (
              <div className={css.footer}>
                {bottomLeftText && (
                  <a
                    className={css.pointerCursor}
                    onTouchTap={this.actionClose(bottomLeftAction)}
                  >
                    {bottomLeftText}
                  </a>
                )}
                {bottomRightText && (
                  <a
                    className={css.pointerCursor}
                    onTouchTap={this.actionClose(bottomRightAction)}
                  >
                    {bottomRightText}
                  </a>
                )}
              </div>
            )}
          </div>
        </Popover>
      </div>
    );
  }
}

PopoverList.defaultProps = {
  bottomLeftAction: () => {},
  bottomRightAction: () => {},
  topRightAction: () => {},
};

PopoverList.propTypes = {
  anchorEl: PropTypes.object,
  bottomLeftAction: PropTypes.func,
  bottomLeftText: PropTypes.string,
  bottomRightAction: PropTypes.func,
  bottomRightText: PropTypes.string,
  children: PropTypes.object,
  classes: PropTypes.object,
  clickItem: PropTypes.func,
  list: PropTypes.array,
  markAsRead: PropTypes.func,
  title: PropTypes.string,
  topRightAction: PropTypes.func,
  topRightText: PropTypes.string,
  topRightSecondaryText: PropTypes.string,
  topRightSecondaryAction: PropTypes.func,
};

export default injectSheet(styles)(PopoverList);



// WEBPACK FOOTER //
// ./src/app/components/app-bar/notification/popover-list.jsx